<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th class="text-left">Employee</th>
          <th class="text-center">Attendance Date</th>
          <th class="text-center">In Time</th>
          <th class="text-center">Out Time</th>
          <th class="text-center">Status</th>
          <th class="text-center">Location</th>
          <th class="text-center">Attendance Remarks</th>
          <th class="text-center">Approval Status</th>
          <th class="text-center">Approval Remarks</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td class="text-left">
            {{ item.contact_profile_name }} <br>
            {{ item.contact_designation }}
          </td>
          <td class="text-center">{{ item.date }}</td>
          <td class="text-center">{{ item.in_time }}</td>
          <td class="text-center">{{ item.out_time }}</td>
          <td class="text-center"></td>
          <td class="text-center"></td>
          <td class="text-center">
             {{ item.in_remarks ? `IN: ${item.in_remarks}` : '' }}
             {{ item.out_remarks ? `OUT: ${item.out_remarks}` : '' }}
          </td>
          <td class="text-center text-capitalize">{{ item.status }}</td>
          <td class="text-center text-capitalize">{{ item.approval_remarks }}</td>
          <td class="text-center">
            <button v-if="['pending'].includes(item.status)" class="btn btn-primary btn-sm"
                    @click="openEditModal(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>
    <AttendanceApprovalModal
        v-if="store.state.isModalOpenTwo"
        :attendanceData="attendanceData"
        @getAttendanceList="getAttendanceList"
    />
  </div>
</template>

<script setup>

import AttendanceApprovalModal from '@/components/molecule/company/hrm-payroll/attendance-approval/AttendanceApprovalModal.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import {ref} from "vue";

const props  = defineProps({
  tableItems     : Object,
  getAttendanceList: Function,
});

const {
  fetchSingleManualAttendance,
} = handleHrPayroll()

const route = useRoute();
const store = useStore();
const attendanceData = ref(null)
const openEditModal = (item) => {
  let query = `?company_id=${route.params.companyId}`;
  fetchSingleManualAttendance(item.id, query).then(res => {
    if (!res.status){
      return
    }
    attendanceData.value = res.data
  });

  store.state.isModalOpenTwo = true
}

</script>
